import * as React from "react";
import { ThemeContext } from "./theme-provider.mjs";
const useTheme = () => {
  const theme = React.useContext(ThemeContext);
  return theme;
};
export {
  useTheme
};
